import { createFileRoute } from '@tanstack/react-router';

import { PluginsPage } from '@/features/plugins/plugins-page';
import { pluginsStore } from '@/features/plugins/plugins.store';

export const Route = createFileRoute('/_authenticated/integrations/')({
  validateSearch: (search: Record<string, unknown>): { connect?: string } =>
    typeof search.connect === 'string' ? { connect: search.connect } : {},
  // A connect link names an app, and apps live on the Connectors tab
  beforeLoad: ({ search }) => {
    if (search.connect) pluginsStore.setActiveTab('integrations');
  },
  component: PluginsPage,
});
